import React, { Fragment } from 'react';
import Vak from '../../models/Vak';
import ToggleSwitch from '../../components/ToggleSwitch';

const FormPartial = (props) => {
  const { vak, setVak } = props;
  let vakObj = new Vak(vak);
  
  const validateValue = (field) => {
    vakObj.validate(field);
  }

  const changeValue = (field, value) => {
    vakObj[field] = value;
    validateValue(field);
    setVak(vakObj.toStateJson());
  }
 
  return <Fragment>
    <div className="mb-1 col-md-6">
      <label htmlFor="name" className="form-label mb-1">Name</label>
      <input
        value={vakObj.name}
        onChange={(e) => changeValue('name', e.target.value)}
        type="text"
        className="form-control form-control-sm font-size-12"
        id="name"
        aria-describedby="name_help"
        placeholder='Enter Name'
      />
      <div id="name_help" className="form-text text-danger mt-0">
        {vakObj.errors.name}
      </div>
    </div>
    <div className="mb-1 col-md-6">
      <label htmlFor="amount" className="form-label mb-1">Total Amount</label>
      <input
        id="amount"
        value={vakObj.amount}
        onChange={(e) => changeValue('amount', e.target.value)}
        type="number"
        className="form-control form-control-sm font-size-12"
        placeholder='₹ 0.00/-'
        aria-describedby="amount_help"
      />
      <div id="amount_help" className="form-text text-danger mt-0">
      {vakObj.errors.amount}
      </div>
    </div>
    <div className="mb-1 col-md-6">
      <label htmlFor="lease_rental" className="form-label mb-1">Lease Rental Amount</label>
      <input
        id="lease_rental"
        value={vakObj.lease_rental}
        onChange={(e) => changeValue('lease_rental', e.target.value)}
        type="number"
        className="form-control form-control-sm font-size-12"
        placeholder='₹ 0.00/-'
        aria-describedby="lease_rental_help"
      />
      <div id="lease_rental_help" className="form-text text-danger mt-0">
      {vakObj.errors.lease_rental}
      </div>
      <div>Activation Amount will be:  {vakObj.activation_amount || 0}</div>
    </div>
    <div className="mb-1 col-md-6">
      <label htmlFor='active' className="form-label mb-0">GLK Type</label>
      <ToggleSwitch
        id="active"
        label_left="Non Rental"
        label_right ="Rental"
        onChange={(e) => {
          vakObj.is_rental = !vakObj.is_rental;
          setVak(vakObj.toStateJson());
        }}
        checked={vakObj.is_rental}
      />
    </div>
  </Fragment>
}

export default FormPartial;
